module.exports = __webpack_public_path__ + "tab_title.a6f73aa5.png";